// Multi-brand source configuration
// Centralises everything related to a lead's `source_site` field so the admin
// dashboard can display brand-specific colors, labels and quick filters.

export const SOURCES = [
  {
    key: "demenageur-pro",
    label: "Déménageur Pro",
    short: "DP",
    color: "#2BD391",      // mint
    text: "#0B4F36",
    bg: "#E8FBF3",
    domain: "demenageur-pro.fr",
    aliases: ["demenageur-pro", "annuaire-demenageurs"],
  },
  {
    key: "luxymove",
    label: "Luxy Move",
    short: "LM",
    color: "#D4A373",      // kraft / luxe
    text: "#5B3A1E",
    bg: "#FBF1E3",
    domain: "luxymove-demenagement.fr",
    aliases: ["luxymove", "luxy-move", "luxymove-demenagement"],
  },
  {
    key: "univerdem",
    label: "Univerdem",
    short: "UD",
    color: "#1D3557",      // navy
    text: "#FFFFFF",
    bg: "#1D3557",
    domain: "univerdem-demenagement.fr",
    aliases: ["univerdem", "univer-dem", "univerdem-demenagement"],
  },
];

export const sourceByKey = (raw) => {
  if (!raw) return SOURCES[0];
  const k = String(raw).toLowerCase().trim();
  return (
    SOURCES.find((s) => s.key === k || s.aliases.includes(k)) || {
      key: k,
      label: k,
      short: k.slice(0, 2).toUpperCase(),
      color: "#5C5C5C",
      text: "#FFFFFF",
      bg: "#5C5C5C",
      domain: "",
      aliases: [],
    }
  );
};

export const aggregateBySource = (bySourceRaw = {}) => {
  // Merge aliases into canonical buckets (e.g. legacy "annuaire-demenageurs" → "demenageur-pro")
  const totals = Object.fromEntries(SOURCES.map((s) => [s.key, 0]));
  Object.entries(bySourceRaw).forEach(([raw, count]) => {
    const s = sourceByKey(raw);
    totals[s.key] = (totals[s.key] || 0) + count;
  });
  return totals;
};
